import Axios from '../utils/axios-utils';


// get all Service Reminder 
export const getAllServiceReminder = async (accountId, from, to, linkedType) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/reminders`, {
            params: { from,  linkedType }
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Service Reminder error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Service Reminder failed" }
        };
    }
};

// get all Renewal Reminder 
export const getAllRenewalReminder = async (accountId, from, to, linkedType) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/reminders`, {
            params: { from,  linkedType }
        });
        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Renewal Reminder error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Renewal Reminder failed" }
        };
    }
};


// update reminder status
export const updateReminderStatus = async (accountId, reminderId, status) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/reminders/${reminderId}/status`, {
            status,
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update reminder Status error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update reminder Status failed" }
        };
    }
};

// get all Reminder statuses
export const getAllReminderStatuses = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/reminders/statuses`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Reminder statuses error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Reminder statuses failed" }
        };
    }
};